"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/hr-HR.ts
var hr_HR_exports = {};
__export(hr_HR_exports, {
  AG_CHARTS_LOCALE_HR_HR: () => AG_CHARTS_LOCALE_HR_HR
});
module.exports = __toCommonJS(hr_HR_exports);
var AG_CHARTS_LOCALE_HR_HR = {
  ariaAnnounceChart: "grafikon, ${seriesCount}[number] serija",
  ariaAnnounceFlowProportionLink: "veza ${index} od ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u010Dvor ${index} od ${count}, ${description}",
  ariaAnnounceGaugeChart: "mjerna ljestvica, ${caption}",
  ariaAnnounceHierarchyChart: "hijerarhijski grafikon, ${caption}",
  ariaAnnounceHierarchyDatum: "razina ${level}[number], ${count}[number] djece, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Pritisnite razmaknicu ili Enter za uklju\u010Divanje/isklju\u010Divanje vidljivosti",
  ariaLabelAddHorizontalLine: "Dodaj vodoravnu liniju",
  ariaLabelAnnotationOptionsToolbar: "Opcije komentara",
  ariaLabelAnnotationSettingsDialog: "Postavke bilje\u0161ki",
  ariaLabelColorPicker: "Bira\u010D boja",
  ariaLabelFinancialCharts: "Financijski grafikoni",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Legenda stavka ${index}[number] od ${count}[number]",
  ariaLabelLegendItemUnknown: "Nepoznata stavka legende",
  ariaLabelLegendPageNext: "Sljede\u0107a stranica legende",
  ariaLabelLegendPagePrevious: "Prethodna stranica legende",
  ariaLabelLegendPagination: "Paginacija legende",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Raspon",
  ariaLabelRangesToolbar: "Rasponi",
  ariaLabelSettingsTabBar: "Postavke",
  ariaLabelZoomToolbar: "Zum",
  ariaValuePanRange: "${min}[percent0to2dp] do ${max}[percent0to2dp]",
  contextMenuDownload: "Preuzmi",
  contextMenuPanToCursor: "Pomakni ovdje",
  contextMenuToggleOtherSeries: "Prebaci ostale serije",
  contextMenuToggleSeriesVisibility: "Prebaci vidljivost",
  contextMenuZoomToCursor: "Pove\u0107aj ovdje",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Datum i cijena",
  dialogHeaderDateRange: "Raspon datuma",
  dialogHeaderFibonacciRange: "Fib Povla\u010Denje",
  dialogHeaderLine: "Linija",
  dialogHeaderPriceRange: "Raspon cijena",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Poravnaj",
  dialogInputColorPicker: "Boja",
  dialogInputColorPickerAltText: "Boja teksta",
  dialogInputExtendAbove: "Pro\u0161iri iznad",
  dialogInputExtendBelow: "Pro\u0161iri ispod",
  dialogInputExtendChannelEnd: "Pro\u0161iri kraj kanala",
  dialogInputExtendChannelStart: "Produ\u017Ei po\u010Detak kanala",
  dialogInputExtendLeft: "Pro\u0161iri lijevo",
  dialogInputExtendLineEnd: "Produ\u017Ei kraj linije",
  dialogInputExtendLineStart: "Produ\u017Ei po\u010Detak linije",
  dialogInputExtendRight: "Pro\u0161iri desno",
  dialogInputFibonacciBands: "Pojasevi",
  dialogInputFibonacciBandsAltText: "Fibonacci Pojasevi",
  dialogInputFillColorPicker: "Ispuna",
  dialogInputFillColorPickerAltText: "Ispuni boju",
  dialogInputFontSize: "Veli\u010Dina",
  dialogInputFontSizeAltText: "Veli\u010Dina fonta",
  dialogInputLineStyle: "Crtkano",
  dialogInputPosition: "Pozicija",
  dialogInputReverse: "Obrnuto",
  dialogInputShowFill: "Prika\u017Ei ispunu",
  dialogInputStrokeWidth: "Debljina",
  dialogInputStrokeWidthAltText: "Debljina crte",
  iconAltTextAlignCenter: "Poravnaj u sredinu",
  iconAltTextAlignLeft: "Lijevo",
  iconAltTextAlignRight: "Desno",
  iconAltTextClose: "Zatvori",
  iconAltTextLineStyleDashed: "Dugih crtica",
  iconAltTextLineStyleDotted: "Kratko-crtkano",
  iconAltTextLineStyleSolid: "Puna",
  iconAltTextPositionBottom: "Dno",
  iconAltTextPositionCenter: "Sredi\u0161te",
  iconAltTextPositionTop: "Vrh",
  inputTextareaPlaceholder: "Dodaj tekst",
  measurerDateRangeBars: "${value}[number] trake",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "U\u010Ditavanje podataka...",
  overlayNoData: "Nema dostupnih podataka za prikaz",
  overlayNoVisibleSeries: "Nema vidljivih serija",
  overlayUnsupportedBrowser: "Nekompatibilna verzija preglednika. Molimo a\u017Eurirajte svoj preglednik.",
  seriesHistogramTooltipCount: "${yName} (broj)",
  seriesHistogramTooltipFrequency: "Frekvencija",
  seriesHistogramTooltipMean: "${yName} (prosjek)",
  seriesHistogramTooltipSum: "${yName} (zbroj)",
  toolbarAnnotationsArrow: "Strelica",
  toolbarAnnotationsArrowDown: "Strelica dolje",
  toolbarAnnotationsArrowUp: "Strelica gore",
  toolbarAnnotationsCallout: "Poziv",
  toolbarAnnotationsClearAll: "O\u010Disti sve",
  toolbarAnnotationsComment: "Komentar",
  toolbarAnnotationsDatePriceRange: "Datum i cijena",
  toolbarAnnotationsDateRange: "Raspon datuma",
  toolbarAnnotationsDelete: "Izbri\u0161i",
  toolbarAnnotationsDisjointChannel: "Diskretni kanal",
  toolbarAnnotationsDragHandle: "Povuci alatnu traku",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Povla\u010Denje",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib temeljen na trendu",
  toolbarAnnotationsFillColor: "Boja ispune",
  toolbarAnnotationsHorizontalLine: "Horizontalna linija",
  toolbarAnnotationsLineAnnotations: "Linije trendova",
  toolbarAnnotationsLineColor: "Boja linije",
  toolbarAnnotationsLineStrokeWidth: "\u0160irina crte poteza",
  toolbarAnnotationsLineStyle: "Stil crte",
  toolbarAnnotationsLock: "Zaklju\u010Daj",
  toolbarAnnotationsMeasurerAnnotations: "Mjerne jedinice",
  toolbarAnnotationsNote: "Bilje\u0161ka",
  toolbarAnnotationsParallelChannel: "Paralelni kanal",
  toolbarAnnotationsPriceRange: "Raspon cijena",
  toolbarAnnotationsQuickDatePriceRange: "Mjera",
  toolbarAnnotationsSettings: "Postavke",
  toolbarAnnotationsShapeAnnotations: "Strelice",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstualne Anotacije",
  toolbarAnnotationsTextColor: "Boja teksta",
  toolbarAnnotationsTextSize: "Veli\u010Dina teksta",
  toolbarAnnotationsTrendLine: "Trend linija",
  toolbarAnnotationsUnlock: "Otklju\u010Daj",
  toolbarAnnotationsVerticalLine: "Vertikalna linija",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mjesec",
  toolbarRange1Year: "1G",
  toolbarRange1YearAria: "1 godina",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mjeseca",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mjeseci",
  toolbarRangeAll: "Sve",
  toolbarRangeAllAria: "Sve",
  toolbarRangeYearToDate: "Godina do danas",
  toolbarRangeYearToDateAria: "Godina do danas",
  toolbarSeriesTypeCandles: "Svije\u0107e",
  toolbarSeriesTypeDropdown: "Vrsta grafikona",
  toolbarSeriesTypeHighLow: "Visoko Nisko",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u0160uplje Svije\u0107e",
  toolbarSeriesTypeLine: "Linija",
  toolbarSeriesTypeLineWithMarkers: "Linija s oznakama",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Korak Linija",
  toolbarZoomPanEnd: "Pomicanje na kraj",
  toolbarZoomPanLeft: "Pomi\u010Dite lijevo",
  toolbarZoomPanRight: "Pomakni desno",
  toolbarZoomPanStart: "Pomakni na po\u010Detak",
  toolbarZoomReset: "Resetiraj pove\u0107anje",
  toolbarZoomZoomIn: "Pove\u0107aj",
  toolbarZoomZoomOut: "Umanji",
  tooltipPaginationStatus: "${index}[number] od ${count}[number]"
};
//# sourceMappingURL=hr-HR.cjs.js.map
